// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * PrivacyChoicesDialog Styles
 * Mirrors WelcomeDialog's glassmorphism look, sized for more content.
 */

.privacy-choices-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2500;
  padding: 20px;
  overflow-y: auto;
}

.privacy-choices-dialog {
  background: rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  padding: 36px;
  max-width: 560px;
  width: 100%;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: privacy-choices-appear 0.4s ease-out;
}

@keyframes privacy-choices-appear {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.privacy-choices-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--color-text, #1f2937);
  margin: 0 0 12px 0;
  text-align: center;
}

.privacy-choices-intro {
  font-size: 1rem;
  color: var(--color-text-secondary, #6b7280);
  line-height: 1.5;
  margin: 0 0 24px 0;
  text-align: center;
}

.privacy-choices-section {
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 14px;
  padding: 18px 20px;
  margin-bottom: 16px;
}

.privacy-choices-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.privacy-choices-section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text, #1f2937);
  margin: 0;
}

.privacy-choices-status-badge {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

.privacy-choices-status-badge.on {
  background: rgba(34, 197, 94, 0.15);
  color: #15803d;
}

.privacy-choices-status-badge.off {
  background: rgba(107, 114, 128, 0.15);
  color: #4b5563;
}

.privacy-choices-status-badge.mixed {
  background: rgba(59, 130, 246, 0.15);
  color: #1d4ed8;
}

.privacy-choices-section-description {
  font-size: 0.9rem;
  color: var(--color-text-secondary, #6b7280);
  margin: 0 0 14px 0;
  line-height: 1.5;
}

.privacy-choices-bulk-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 10px;
}

.privacy-choices-bulk-btn {
  flex: 1 1;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid var(--color-border, #d1d5db);
  background: var(--color-background, #f3f4f6);
  color: var(--color-text, #1f2937);
  transition: all 0.15s ease;
}

.privacy-choices-bulk-btn:hover:not(:disabled) {
  background: var(--color-border, #d1d5db);
}

.privacy-choices-bulk-btn.allow {
  background: var(--color-primary, #3b82f6);
  color: white;
  border-color: var(--color-primary, #3b82f6);
}

.privacy-choices-bulk-btn.allow:hover:not(:disabled) {
  background: var(--color-primary-hover, #2563eb);
}

.privacy-choices-bulk-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.privacy-choices-customize-toggle {
  background: none;
  border: none;
  color: var(--color-primary, #3b82f6);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 0;
}

.privacy-choices-details {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed var(--color-border, #e5e7eb);
}

.privacy-choices-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
}

.privacy-choices-row.disabled {
  opacity: 0.55;
}

.privacy-choices-row-label {
  font-size: 0.9rem;
  color: var(--color-text, #1f2937);
}

.privacy-choices-note {
  font-size: 0.82rem;
  color: var(--color-text-secondary, #6b7280);
  margin: 6px 0;
  line-height: 1.4;
}

.privacy-choices-footer-note {
  font-size: 0.78rem;
  color: var(--color-text-secondary, #6b7280);
  line-height: 1.5;
  margin: 18px 0;
  text-align: center;
}

.privacy-choices-footer-note a {
  color: var(--color-primary, #3b82f6);
  text-decoration: underline;
}

.privacy-choices-continue-btn {
  display: block;
  width: 100%;
  padding: 14px;
  border-radius: 12px;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: var(--color-primary, #3b82f6);
  color: white;
  transition: all 0.2s ease;
}

.privacy-choices-continue-btn:hover {
  background: var(--color-primary-hover, #2563eb);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

@media (max-width: 480px) {
  .privacy-choices-dialog {
    padding: 24px;
  }

  .privacy-choices-bulk-actions {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PrivacyChoicesDialog.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,4CAA4C;EAC5C,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/**\n * PrivacyChoicesDialog Styles\n * Mirrors WelcomeDialog's glassmorphism look, sized for more content.\n */\n\n.privacy-choices-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2500;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.privacy-choices-dialog {\n  background: rgba(255, 255, 255, 0.97);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 20px;\n  padding: 36px;\n  max-width: 560px;\n  width: 100%;\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  animation: privacy-choices-appear 0.4s ease-out;\n}\n\n@keyframes privacy-choices-appear {\n  from { opacity: 0; transform: scale(0.95); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.privacy-choices-title {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--color-text, #1f2937);\n  margin: 0 0 12px 0;\n  text-align: center;\n}\n\n.privacy-choices-intro {\n  font-size: 1rem;\n  color: var(--color-text-secondary, #6b7280);\n  line-height: 1.5;\n  margin: 0 0 24px 0;\n  text-align: center;\n}\n\n.privacy-choices-section {\n  border: 1px solid var(--color-border, #e5e7eb);\n  border-radius: 14px;\n  padding: 18px 20px;\n  margin-bottom: 16px;\n}\n\n.privacy-choices-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 6px;\n}\n\n.privacy-choices-section-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-text, #1f2937);\n  margin: 0;\n}\n\n.privacy-choices-status-badge {\n  flex-shrink: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  padding: 3px 10px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.privacy-choices-status-badge.on {\n  background: rgba(34, 197, 94, 0.15);\n  color: #15803d;\n}\n\n.privacy-choices-status-badge.off {\n  background: rgba(107, 114, 128, 0.15);\n  color: #4b5563;\n}\n\n.privacy-choices-status-badge.mixed {\n  background: rgba(59, 130, 246, 0.15);\n  color: #1d4ed8;\n}\n\n.privacy-choices-section-description {\n  font-size: 0.9rem;\n  color: var(--color-text-secondary, #6b7280);\n  margin: 0 0 14px 0;\n  line-height: 1.5;\n}\n\n.privacy-choices-bulk-actions {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.privacy-choices-bulk-btn {\n  flex: 1;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid var(--color-border, #d1d5db);\n  background: var(--color-background, #f3f4f6);\n  color: var(--color-text, #1f2937);\n  transition: all 0.15s ease;\n}\n\n.privacy-choices-bulk-btn:hover:not(:disabled) {\n  background: var(--color-border, #d1d5db);\n}\n\n.privacy-choices-bulk-btn.allow {\n  background: var(--color-primary, #3b82f6);\n  color: white;\n  border-color: var(--color-primary, #3b82f6);\n}\n\n.privacy-choices-bulk-btn.allow:hover:not(:disabled) {\n  background: var(--color-primary-hover, #2563eb);\n}\n\n.privacy-choices-bulk-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.privacy-choices-customize-toggle {\n  background: none;\n  border: none;\n  color: var(--color-primary, #3b82f6);\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 4px 0;\n}\n\n.privacy-choices-details {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px dashed var(--color-border, #e5e7eb);\n}\n\n.privacy-choices-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.privacy-choices-row.disabled {\n  opacity: 0.55;\n}\n\n.privacy-choices-row-label {\n  font-size: 0.9rem;\n  color: var(--color-text, #1f2937);\n}\n\n.privacy-choices-note {\n  font-size: 0.82rem;\n  color: var(--color-text-secondary, #6b7280);\n  margin: 6px 0;\n  line-height: 1.4;\n}\n\n.privacy-choices-footer-note {\n  font-size: 0.78rem;\n  color: var(--color-text-secondary, #6b7280);\n  line-height: 1.5;\n  margin: 18px 0;\n  text-align: center;\n}\n\n.privacy-choices-footer-note a {\n  color: var(--color-primary, #3b82f6);\n  text-decoration: underline;\n}\n\n.privacy-choices-continue-btn {\n  display: block;\n  width: 100%;\n  padding: 14px;\n  border-radius: 12px;\n  font-size: 1.05rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  background: var(--color-primary, #3b82f6);\n  color: white;\n  transition: all 0.2s ease;\n}\n\n.privacy-choices-continue-btn:hover {\n  background: var(--color-primary-hover, #2563eb);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n@media (max-width: 480px) {\n  .privacy-choices-dialog {\n    padding: 24px;\n  }\n\n  .privacy-choices-bulk-actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
